<template>
  <td
    :class="classes"
    class="text-left bg-base-0 px-2 py-3 border-t border-b border-transparent"
    @click="$emit('click', $event)"
  >
    <slot />
  </td>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null,
    },
  },
  data() {
    const showOverXlColumns = [
      'createdAt',
      'counter',
      'presentButton',
    ]

    const showOver2xlColumns = [
      'owner',
      'onlineCount',
    ]

    return {
      classes: {
        'hidden xl:table-cell': showOverXlColumns.includes(this.name),
        'hidden 2xl:table-cell': showOver2xlColumns.includes(this.name),
      },
    }
  },
}
</script>
